import state from './state'
import getters from './getters' // Change from * as getters
import mutations from './mutations' // Assuming default export in mutations.js
// eslint-disable-next-line import/no-cycle
import actions from './actions' // Assuming default export in actions.js

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
